<template>
  <div>




      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li>
                          <button v-if="deviceSharingEnableFlag" type="button" @click="shareEntity()" ><i class="fa fa-share-alt fa-2x push-15-r "></i></button>
                      </li>

                      <li v-if="flagDisplayDevice===0">
                          <button type="button" @click="toggleDisplayDevice()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayDevice">
                          <button  type="button" @click="toggleDisplayDevice()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="h3 block-title" @click="toggleDisplayDevice()"><i class="fa fa-server fa-1x push-5-r "></i>{{tempoBundle.devices[deviceIndex].ReferenceName}}</h2>
            </div>

            <div v-if="flagDisplayDevice" class="block-content">

              <div class="row">
                <div class="col-xs-12">

                    <!-- Section parametre module -->
                    <div class="block">
                        <div class="col-xs-12">
                          <div class="form-group">
                              <label class="col-xs-12">{{ textLabelReferenceName[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <input v-model="tempoBundle.devices[deviceIndex].ReferenceName" class="form-control"  placeholder="Entrez votre information">
                              </div>
                          </div>
                        </div>
                        <div class="col-xs-12"><hr></hr></div>


                        <div v-if = "true">
                          <div class="col-xs-12">
                            <div  class="col-xs-12 col-md-8">
                              <div class="form-group">
                                  <label class="col-xs-12 col-md-12">{{ textLabelModuleName[actualLanguage] }}</label>
                                  <div class="col-sm-12">
                                      <input v-model="tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.name" class="form-control" type="test" placeholder="Entrez votre information">
                                  </div>
                              </div>

                              <div class="col-xs-12 col-sm-12">
                                <div class="form-group">
                                    <label class="col-xs-12">{{ textLabelModuleID[actualLanguage] }}</label>
                                    <div class="col-sm-12">
                                        <div class="form-control-static">{{tempoBundle.devices[deviceIndex].DeviceData.deviceId}}</div>
                                    </div>
                                </div>
                              </div>

                              <div class="col-xs-12 col-sm-12">
                                <div class="form-group">
                                    <label class="col-xs-12">{{ textLabelModuleSN[actualLanguage] }}</label>
                                    <div class="col-sm-12">
                                        <div class="form-control-static">{{tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.serialNumber}}</div>
                                    </div>
                                </div>

                                
                                <div v-if = "displayCloudLiveButton & actualBundle.bundleRights.realTimeMeasurementPanel" class="form-group align-center">
                                  <div class="col-sm-12">
                                    
                                    <button  class="btn btn-default" @click="loadCloudLive()" >
                                      <spinner size="small" v-if="flagCloudLiveIsActivating"></spinner>
                                      <i v-else class="fa fa-cloud-download fa-1x push-15-r "></i>Cloud Live</button>
                                  </div>
                                </div>

                                <div v-if = "displayLiveButton" class="form-group align-left">
                                  <div class="col-sm-12">
                                    <button  class="btn btn-default" @click="loadLiveMonitor()">Live monitor</button>
                                  </div>
                                  <div class="col-sm-12">
                                    <label class="col-xs-12">{{ liveMonitorMessage[actualLanguage] }}</label>
                                  </div>

                                </div>


                              </div>

                            </div>

                              <div  class="col-xs-12 col-md-4">
                                <div class="form-group">
                                  <p><img class = "img-responsive"  width="150px" :src="`devices/${tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.devicePicture}` | s3Image"></p>
                                </div>
                              </div>
                          </div>


                          <div class="col-xs-12"><hr></hr></div>

                        </div>
                    </div>
                    <!-- END Section paramètre module -->

                    <div v-if="tempoBundle.devices[deviceIndex].DeviceData.frontendComponents.componentDeviceConfig=='EVA_V1P00'">
                      <div v-if="deviceConfigViewFlag" class="row">
                        <div class="col-xs-12">
                          <div class="block block-bordered">
                            <div class="block block-themed">
                              <div class="block-header bg-muted">
                                <ul class="block-options">
                                    <li v-if="flagDisplayPortCfg===0">
                                        <button type="button" @click="togglePortCfg()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                    </li>
                                    <li v-if="flagDisplayPortCfg">
                                        <button  type="button" @click="togglePortCfg()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                    </li>
                                </ul>
                                <h2 class="block-title" @click="togglePortCfg()">{{ sectionLabelPortConfiguration[actualLanguage] }}</h2>
                              </div>
                              <div v-if="flagDisplayPortCfg" class="block-content">
                                <div class="row">
                                <div class="col-xs-12 col-sm-12">
                                  <div class="table-responsive">

                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th class="h5 text-center" style="width: 50px;">Port</th>
                                                <th class="h5 text-center" style="width: 20%;">{{ tableLabelSensorFactor[actualLanguage] }}</th>
                                                <th class="h5 text-center" style="width: 30%;">{{ tableLabelCircuitVoltage[actualLanguage] }}</th>
                                                <th class="h5 text-center" style="width: 30%;">{{ tableLabelAvrPowerFactor[actualLanguage] }}</th>
                                            </tr>
                                        </thead>
                                        <tbody>   
                                              <tr v-for="(port,index) in tempoBundle.devices[deviceIndex].DeviceData.portsConfig">
                                                  <td class="text-center">{{port.portId}}</td>
                                                  <td>
                                                    <input v-model="port.sensorFactor" class="form-control align-center" type="test"  placeholder="Entrez votre information">
                                                  </td>
                                                  <td class="text-center">
                                                      <input v-model="port.portVoltage" class="form-control align-center" type="test"  placeholder="Entrez votre information">
                                                  </td>
                                                  <td class="text-center">
                                                      <input v-model="port.powerFactor" class="form-control align-center" type="test"  placeholder="Entrez votre information">
                                                  </td>
                                              </tr>
                                        </tbody>
                                    </table>
                                    </div>
                                    </div>
                                    </div>


                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>



                    <div class="row">
                      <div class="col-xs-12">
                        <div class="block block-bordered">
                          <div class="block block-themed">
                            <div class="block-header bg-muted">
                              <ul class="block-options">
                                  <li v-if="flagDisplayMap===0">
                                      <button type="button" @click="togglePlanMap()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                  </li>
                                  <li v-if="flagDisplayMap">
                                      <button  type="button" @click="togglePlanMap()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                  </li>
                              </ul>
                              <h2 class="block-title" @click="togglePlanMap()">{{ sectionLabelLocalisation[actualLanguage] }}</h2>
                            </div>
                            <div v-if="flagDisplayMap" class="block-content">
                              <div class="row">
                              <div class="h4 col-xs-12">
                                <div class="h4 form-material col-xs-12">
                                  <label>{{ labelFieldDeviceAddress[actualLanguage] }}</label>
                                </div>

                                <div class="h4 form-material">
                                  <gmap-autocomplete class="form-control" style="width: 100%; margin-bottom: 5px"
                                    @place_changed="usePlace"
                                    :placeholder="locationString">
                                  </gmap-autocomplete>
                                </div>

                                <div class="h4 col-xs-12">
                                <Gmap-Map style="width: 100%; height: 300px;" :zoom="7" :center="center">
                                  <Gmap-Marker v-for="(marker, index) in markers"
                                    :key="index"
                                    :position="marker.position"
                                    :draggable='true'
                                    ></Gmap-Marker>
                                    <!-- @dragEnd="markerDrag" -->
                                  <!-- <Gmap-Marker
                                    v-if="this.place"
                                    :position="{
                                      lat: this.place.geometry.location.lat(),
                                      lng: this.place.geometry.location.lng(),
                                    }"
                                    ></Gmap-Marker> -->
                                </Gmap-Map>
                                </div>
                              </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div v-if="deviceConfigViewFlag" class="block">
                      <config-device-plan :deviceIndex="deviceIndex" ></config-device-plan>
                    </div>              


                    <div v-if="deviceConfigViewFlag" class="row">
                      <div class="col-xs-12">
                        <div class="block block-bordered">
                          <div class="block block-themed">
                            <div class="block-header bg-muted">
                              <ul class="block-options">
                                  <li v-if="flagDisplayListOfChannel===0">
                                      <button type="button" @click="toggleListOfChannel()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                  </li>
                                  <li v-if="flagDisplayListOfChannel">
                                      <button  type="button" @click="toggleListOfChannel()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                  </li>
                              </ul>
                              <h2 class="block-title" @click="toggleListOfChannel()">{{ sectionLabelLinkedChannel[actualLanguage] }}</h2>
                            </div>
                            <div v-if="flagDisplayListOfChannel" class="block-content">
                                <spinner size="small" v-if="deviceLinkedChannelIsReading"></spinner>
                                <div v-else class="row">
                                  <div class="col-xs-12 col-sm-12">
                                    <div class="table-responsive">

                                  <table class="table">
                                      <thead>
                                          <tr>
                                              <th class="h5 text-center" style="width: 30%;">{{tableLinkedChannelChannelName[actualLanguage]}}</th>
                                              <th class="h5 text-center" style="width: 30%;">{{tableLinkedChannelUserOrg[actualLanguage]}}</th>
                                              <th class="h5 text-center" style="width: 30%;">{{tableLinkedChannelBundle[actualLanguage]}}</th>
                                              <th class="h5 text-center" style="width: 20%;">{{tableLinkedChannelPort[actualLanguage]}}</th>
                                          </tr>
                                      </thead>
                                      <tbody>   
                                            <tr v-for="(channel,index) in deviceListOfLinkedChannel">
                                                <td class="text-center">{{channel.ChannelName}}</td>
                                                <td class="text-center">{{channel.ParentBundleOwner}}</td>
                                                <td class="text-center">{{channel.ParentBundle}}</td>
                                                <td class="text-center">{{channel.Port}}</td>
                                            </tr>
                                      </tbody>
                                  </table>
                                </div>
                                </div>
                                </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div v-if="bundleConfigEditFlag" class="row">

                      <div class="col-xs-12 col-sm-12 col-md-6">
                        <p><button @click="confirmRemoveDevice()" type="button" class="h4 btn btn-danger align-left" name="button">
                          <spinner size="small" v-if="deviceIsDeleting"></spinner>
                          <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ labelFieldButtonConfirmDeleteDevice[actualLanguage] }}</span></button></p>
                      </div>

                      <div v-if="deviceConfigEditFlag" class="col-xs-12 col-sm-12 col-md-6">
                        <p><button @click="saveDeviceModifications()" type="button" class="h4 btn btn-success align-right" name="button">
                          <spinner size="small" v-if="deviceIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelFieldButtonConfirmSaveDevice[actualLanguage] }}</span></button></p>
                      </div>
                    </div>

                </div>
              </div>

            </div>
        </div>
      </div>
      </div>
    </div>
  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import electPlanDef from '@/views/configuration/ElectricalPlanDefinition.js'
import ConfigDevicePlan from './ConfigDevicePlan'
import Spinner from '@/components/Spinner'
import ConfigSharingList from './SubComponent/ConfigSharingList'


export default {
  props: ['deviceIndex'],
  components: {
    Spinner,
    ConfigDevicePlan,
    ConfigSharingList
  },
  data() {
    return {
      tempoBundle : {},
      center: {lat: 46, lng: 71},
      markers: [],
      place: null,
      flagDisplayMap: 0,
      flagDisplayPortCfg : 0,
      flagDisplayDevice : 0,
      deviceIsSaving : false,
      deviceIsDeleting : false,
      displayCloudLiveButton : false,
      displayLiveButton : false,
      flagCloudLiveIsActivating : false,
      electricalPlanDefinitions : electPlanDef,
      locationString : '',

      flagDisplayListOfChannel : 0,
      deviceLinkedChannelIsReading : false,
      deviceListOfLinkedChannel : [],
      
      actualLanguage : "FR",
      flagDisplaySelectPlan : false,
      labelFieldDeviceName: {FR: "Nom de l'appareil", EN: 'Device name'},
      labelFieldDeviceAddress: {FR: "Localisation du module (adresse)", EN: 'Device location (address)'},
      labelFieldTitleBillPlan: {FR: 'Plan de tarification électrique', EN: 'Electrical billing plan'},
      labelApplyButtonBillPlan: {FR: 'Appliquer', EN: 'Apply'},
      labelCancelButtonBillPlan: {FR: 'Annuler', EN: 'Cancel'},
      labelSelectPreRecBillPlan: {FR: 'Sélectionner un plan pré-enregistré', EN: 'Select pre-recorded plan'},
      labelSelectPlan: {FR: 'Sélectionner un plan', EN: 'Select plan'},
      labelFieldTitleBasePrice: {FR: 'Tarif de base:', EN: 'Base price:'},
      labelFieldTitleTarif: {FR: 'Tarif ($/kWh)', EN: 'Price ($/kWh)'},
      labelFieldOptionHoraire: {FR: 'Horaire', EN: 'Scheduled'},
      labelFieldOptionTemperature: {FR: 'Température', EN: 'Temperature'},
      labelFieldTitleStartMonth: {FR: 'Mois début', EN: 'Start month'},
      labelFieldTitleEndMonth: {FR: 'Mois fin', EN: 'End month'},
      labelFieldTitleStartDay: {FR: 'Jour début', EN: 'Start day'},
      labelFieldTitleEndDay: {FR: 'Jour fin', EN: 'End day'},
      labelFieldTitleStartHour: {FR: 'Heure début', EN: 'Start hour'},
      labelFieldTitleEndHour: {FR: 'Heure fin', EN: 'End hour'},
      labelFieldOptionUnder: {FR: 'Inférieur à:', EN: 'Under:'},
      labelFieldOptionOver: {FR: 'Supérieur à:', EN: 'Over:'},
      labelFieldTitleTempThld: {FR: 'Température seuil (C)', EN: 'Threshold température (C)'},
      labelFieldButtonDelete: {FR: 'Supprimer', EN: 'Delete'},
      labelFieldButtonAddCond: {FR: 'Ajouter une condition au plan', EN: 'Add billing plan condition'},
      labelField: {FR: '', EN: ''},
      labelFieldButtonConfirmDeleteDevice: {FR: "Supprimer le module", EN: 'Delete module'},
      labelFieldButtonConfirmSaveDevice: {FR: "Sauvegarder les paramètres du module", EN: 'Save module parameters'},
      deviceSaveMessage:{FR: "Attention, si le nom de référence a été modifié, il est possible que la position dans la liste soit modifiée!",
                      EN: 'Attention, if the reference name changed, it is possible that the module position in the list change!'},

      textLabelReferenceName: {FR: "Nom de référence", EN: 'Referencen name'},
      textLabelModuleName: {FR: "Nom du module", EN: 'Module name'},
      textLabelModuleID: {FR: "Identifiant du module", EN: 'Module ID'},
      textLabelModuleSN: {FR: "Numéro de série", EN: 'Serial number'},
      liveMonitorMessage: {FR: "Le Live Monitor requiert que l'appareil d'observation (ordinateur, tablette, téléphone) soit branché au même routeur que le module",
                             EN: 'The Live Monitor requires that observation device (computer, tablet, mobile) is connected on the same router than the module.'},
      sectionLabelPortConfiguration:{FR: "Configuration des ports de mesure", EN: 'Measurement port configuration'},
      tableLabelSensorFactor:{FR: "Facteur de multiplication du capteur", EN: 'Sensor multiplication factor'},
      tableLabelCircuitVoltage:{FR: "Tension du circuit", EN: 'Circuit voltage'},
      tableLabelAvrPowerFactor:{FR: "Facteur de puissance moyen", EN: 'Power factor (average)'},
      sectionLabelLocalisation:{FR: "Localisation du module", EN: 'Module location'},

      sectionLabelLinkedChannel:{FR: "Appareils liés au module", EN: 'Linked devices to this module'},

      tableLinkedChannelChannelName:{FR: "Nom d'appareil", EN: 'Device name'},
      tableLinkedChannelUserOrg:{FR: "Utilisateur/Organisation", EN: 'User/Organization'},
      tableLinkedChannelBundle:{FR: "Nom du système", EN: 'System name'},
      tableLinkedChannelPort:{FR: "Ports", EN: 'Ports'},

      messageRemoveDevice:{FR: "ATTENTION : La supression d'un module dont vous êtes propriétaire supprime automatiquement les partages et les appareils et alertes liés a ces partages! Si ce module provient d'un partage il sera uniquement retiré de votre système.",
                              EN: 'WARNING : The module deletion that you are owner will automatically delete all sharings and all device and alert linked to these sharings! If this module comes from a sharing, it will be only removed from your system.'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du module : ", EN: 'Confirm module deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

      deviceConfigViewFlag : false,
      deviceConfigEditFlag : false,
      deviceConfigDeleteFlag : false,
      deviceSharingEnableFlag : false,

      bundleConfigEditFlag : false,

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle','parentContainer']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },
  },

  methods: {
  ...mapActions('overlayStore', ['showModal']),

   toggleDisplayDevice(){
      this.flagDisplayDevice = ~this.flagDisplayDevice
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },

    togglePlanMap(){
      this.flagDisplayMap = ~this.flagDisplayMap
    },

    togglePortCfg(){
      this.flagDisplayPortCfg = ~this.flagDisplayPortCfg
    },

    toggleListOfChannel(){
      this.flagDisplayListOfChannel = ~this.flagDisplayListOfChannel
      if(this.flagDisplayListOfChannel==-1){this.getDeviceListOfLinkedChannels()}
    },


    usePlace(place) {
      let newLat = place.geometry.location.lat()
      let newLng = place.geometry.location.lng()
      this.center = {lat: newLat, lng: newLng}
      this.place = place
      this.locationString = place.formatted_address
      this.markers= [{
        position: {
          lat: newLat,
          lng: newLng,
        }
      }]
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude  = newLat
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude = newLng
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress = place.formatted_address
      this.place = null;
    },

    saveDeviceModifications() {
        //Copie de DevicePlan dans tempoBundle puisque le component change le actualBundle
        this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan
        this.deviceIsSaving = true
        var requestData = { 'postAction':'SaveDeviceModification',
                            'bundleId': this.tempoBundle.bundle_id,
                            'deviceIndex': this.tempoBundle.devices[this.deviceIndex].DeviceBundleIndex,
                            'deviceData':JSON.parse(JSON.stringify(this.tempoBundle.devices[this.deviceIndex]))
                            }
        //console.log(requestData)      
        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
              //console.log(response.data)
              this.deviceIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                window.alert(this.deviceSaveMessage[this.actualLanguage])
                this.$store.dispatch('sessionStore/reloadActualBundle')
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
      
    },

    getDeviceListOfLinkedChannels() {
        //Copie de DevicePlan dans tempoBundle puisque le component change le actualBundle

        this.deviceLinkedChannelIsReading = true
        var requestData = { 'postAction':'GetDeviceListOfLinkedChannel',
                            'bundleId': this.tempoBundle.bundle_id,
                            'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                            }
        //console.log(requestData)      
        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
              //console.log(response.data)
              this.deviceLinkedChannelIsReading = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                this.deviceListOfLinkedChannel = response.data.LinkedChannelList
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
      
    },



    confirmRemoveDevice(){
          window.alert(this.messageRemoveDevice[this.actualLanguage])
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.tempoBundle.devices[this.deviceIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.deviceIsDeleting = true
              var requestData = { 'postAction':'RemoveDeviceFromBundle',
                                  'deviceIndex':this.tempoBundle.devices[this.deviceIndex].DeviceBundleIndex,
                                  'bundleId': this.tempoBundle.bundle_id,
                                  'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                                  'parentContainer':this.parentContainer,
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    //console.log(response.data)
                    this.deviceIsDeleting = false
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.$store.dispatch('sessionStore/reloadActualBundle')
                      this.alertShowAddButton=true
                      }
                      else{ window.alert(this.messagePostFail[this.actualLanguage] )}
                  })       
          }

    },


    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de module", EN: 'Module sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Device',
                        'entityId':this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                        'entityReferenceName':this.tempoBundle.devices[this.deviceIndex].ReferenceName,
                        'displayAlertOptions':false,
                        'displayChannelOptions':false,
                        'displayDeviceOptions':true,
                        'displayBundleOptions':false,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },

    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value Found')
          }
        }
        return value
    },

    loadLiveMonitor() {
      var localUrl ='http://' + this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.localIpAddr + '/live';      
      window.open(localUrl, '_blank');
      
    },


    loadCloudLive(){
        this.flagCloudLiveIsActivating = true
        var requestData = { 'postAction':'EnableDeviceLiveCloudReadings',
                            'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                            }     
        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
            //response.data.Code='OK'
            this.flagCloudLiveIsActivating = false
            if(response.data.Code=='OK'){
                  var modalParameters = {
                              'liveType':'Device',
                              'deviceIndex':this.deviceIndex,
                              'deviceId':this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                                    }
                                    
                  this.$store.dispatch('overlayStore/setParameters',modalParameters)
                  this.showModal('channel-cloud-live-modal-display')                
                }
                else{ window.alert(response.data.PromptMessage[this.actualLanguage])}
            })  
    },

  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    this.locationString = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress

    this.deviceConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceConfigView')
    this.deviceConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceConfigEdit')
    this.deviceConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceConfigDelete')
    this.deviceSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceSharingEnable')

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigEdit')

    this.displayCloudLiveButton = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.model.includes('CM6')
    this.displayLiveButton = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.model.includes('MM6')


    this.markers = [{
        position: {
          lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
          lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude,
        }
      }]
    this.center = {lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
                   lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude}

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },

  beforeMount(){
    this.reloadTempoBundle()
  }

}
</script>

<style lang="css">
  .h1 {font-size: 24px;}
  .h2 {font-size: 20px;}
  .h3 {font-size: 16px;}
  .h4 {font-size: 16px;}
  .h5 {font-size: 12px;}
  table thead th.h5 {font-size: 14px;}

  /* Media Query pour les écrans de moins de 600px de large */
  @media (max-width: 600px) {
      .h1 {font-size: 18px;}
      .h2 {font-size: 16px;}
      .h3 {font-size: 14px;}
      .h4 {font-size: 10px;}
      .h5 {font-size: 8px;}
      table thead th.h5 {font-size: 10px;}
  }

</style>



// WEBPACK FOOTER //
// ConfigDevice.vue?5e3acc2e